import { useEffect, useState } from 'react';

const defaultOrientation = 'vertical';

export const useImgOrientation = (src) => {
  const [orientation, setOrientation] = useState(null);

  useEffect(() => {
    if (!src) {
      setOrientation(defaultOrientation);
      return;
    }

    const img = new Image();
    img.src = src;
    img.onload = () => {
      const isHorizontal = img.width > img.height;
      const isVertical = img.height > img.width;

      if (isHorizontal) setOrientation('horizontal');
      else if (isVertical) setOrientation('vertical');
      else setOrientation('vertical');
    };

    img.onerror = () => {
      console.error('Не удалось загрузить изображение');
      setOrientation('error');
    };
  }, [src]);

  return { orientation };
};
